<template>
  <div>
    <form data-vv-scope="custom-document-part-1">
      <h2 class="mb-10">Bitácora {{ anio }}</h2>
      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Vehículo *">
            <v-select
              class="w-100"
              :class="{
              'v-select-danger': errors.has('custom-document-part-1.vehicle')
            }"
              data-cy="vehicle"
              data-vv-as="vehículo"
              name="vehicle"
              :options="optionsVehicles"
              v-model="formData.vehicle"
              v-validate="'required'"
            >
              <template #spinner>
                <b-spinner
                  small
                  v-if="isLoadVehiclesOptions"
                  :style="{ opacity: isLoadVehiclesOptions ? 1 : 0}"
                  variant="primary"
                />
              </template>
              <template slot="no-options">
                no hay vehículos para el criterio de búsqueda
              </template>
            </v-select>
            <div
              v-if="errors.has('custom-document-part-1.vehicle')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
            <span class="span-text-validation">
              {{ errors.first('custom-document-part-1.vehicle') }}
            </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-5 ml-5">
          <list-user
            autocomplete
            class="w-100"
            label="Conductor *"
            name="driver"
            data-cy="driver"
            data-vv-as="conductor"
            v-model="formData.driver"
            ref="driver"
            :danger="errors.has('custom-document-part-1.driver')"
            :danger-text="errors.first('custom-document-part-1.driver')"
            v-validate="'required'"
            :group-filter="driverGroupId"
          />
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-2">
      <div class="row mb-3">
        <div class="col-md-12">
          <h4>Destinos *</h4>
        </div>
        <div class="col-md-12 mt-3">
          <add-destinations @add-destination="addDestination" />
        </div>
        <div class="col-md-12 mt-3">
          <table-destinations
            :destinations="formData.destinations"
            v-model="formData.destinationsSelected"
            multiple
          />
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-3">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Objetivo del cometido *">
            <b-form-textarea
              :state="errors.has('custom-document-part-3.objectiveTask') ? false : null"
              data-cy="objective-task"
              data-vv-as="objetivo del cometido"
              name="objectiveTask"
              type="text"
              rows="3"
              v-model="formData.objectiveTask"
              v-validate="'required'"
              maxLength="5000"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{formData.objectiveTask.length}}/5000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document-part-3.objectiveTask')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
            <span class="span-text-validation">
              {{ errors.first('custom-document-part-3.objectiveTask') }}
            </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-4">
      <div class="row">
        <div class="col-md-12">
          <h4>Pasajeros *</h4>
        </div>
        <div class="col-md-12 mt-3">
          <select-passengers @add-passenger="addPassenger" />
        </div>
        <div class="col-md-12 mt-3">
          <table-passengers
            :passengers="formData.passengers"
            v-model="formData.passengersSelected"
            multiple
          />
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-5">
      <div class="row">
        <div class="col-md-12">
          <h4>Carga combustible</h4>
        </div>
        <div class="col-md-12 mt-3">
          <add-charge-gasoline @add-charge-gasoline="addChargeGasoline" />
        </div>
        <div class="col-md-12 mt-3">
          <table-charge-gasoline
            :loadsGasoline="formData.loadsGasoline"
            v-model="formData.loadsGasolineSelected"
            multiple
          />
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="custom-document-part-6">
      <div class="row">
        <div class="col-md-12">
          <h4>Informe de incidentes</h4>
        </div>
        <div class="col-md-6 mt-3">
          <b-form-group label="Conductor">
            <b-form-input
              data-cy="incident-driver"
              name="incidentDriver"
              type="text"
              v-model="formData.incidentDriver"
              maxLength="150"
            />
          </b-form-group>
        </div>
        <div class="col-md-6 mt-3">
          <b-form-group label="Rut">
            <b-form-input
              data-cy="incident-driver-iut"
              name="incidentDriverIut"
              type="text"
              v-model="formData.incidentDriverIut"
              :state="errors.has('custom-document-part-6.incidentDriverIut') ? false : null"
              placeholder="12345678-9"
              v-validate="'validateRut'"
            />
            <div
              v-if="errors.has('custom-document-part-6.incidentDriverIut')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
            <span class="span-text-validation">
              {{ errors.first('custom-document-part-6.incidentDriverIut') }}
            </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Comuna">
            <b-form-input
              data-cy="incident-commune"
              name="incidentCommune"
              type="text"
              v-model="formData.incidentCommune"
              maxLength="150"
            />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Sector">
            <b-form-input
              data-cy="incident-sector"
              name="incidentSector"
              type="text"
              v-model="formData.incidentSector"
              maxLength="150"
            />
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group
            label="Descripción (hora, calles, patente otro vehículo, celular, heridos)"
          >
            <b-form-textarea
              data-cy="incident-description"
              name="incidentDescription"
              type="text"
              rows="3"
              v-model="formData.incidentDescription"
              maxLength="5000"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{formData.incidentDescription.length}}/5000
              </small>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <vs-divider />
        </div>
        <div class="col-md-12">
          <b-form-group label="Observaciones">
            <b-form-textarea
              data-cy="observations"
              name="observations"
              type="text"
              rows="3"
              v-model="formData.observations"
              maxLength="5000"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{formData.observations.length}}/5000
              </small>
            </div>
          </b-form-group>
        </div>
      </div>
    </form>
    <div
      v-if="error.message !== ''"
      class="con-text-validation span-text-validation-danger
            vs-input--text-validation-span v-enter-to text-right"
      style="height: 32px;"
    >
      <span class="span-text-validation">
        {{ error.message }}
      </span>
    </div>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';
import ListUser from '@/febos/chile/lists/components/ListUser';
import AddDestinations
  from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/AddDestinations';
import TableDestinations
  from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableDestinations';
import SelectPassengers
  from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectPassengers';
import TablePassengers from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/TablePassengers';
import AddChargeGasoline from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/AddChargeGasoline';
import TableChargeGasoline
  from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableChargeGasoline';

const CODE_GROUP_DRIVERS_GORE = '31/2/2';

export default {
  name: 'BIT',
  components: {
    ListUser,
    AddDestinations,
    SelectPassengers,
    TableDestinations,
    TablePassengers,
    AddChargeGasoline,
    TableChargeGasoline
  },
  data() {
    return {
      error: {
        message: ''
      },
      anio: new Date().getFullYear(),
      formData: {
        driver: '',
        vehicle: '',
        destinations: [],
        destinationsSelected: [],
        objectiveTask: '',
        passengers: [],
        passengersSelected: [],
        incidentDriver: '',
        incidentDriverIut: '',
        incidentCommune: '',
        incidentSector: '',
        incidentDescription: '',
        observations: '',
        loadsGasoline: [],
        loadsGasolineSelected: []
      },
      optionsVehicles: [],
      isLoadVehiclesOptions: false,
      saving: false,
      driverGroupId: null
    };
  },
  watch: {
    destinations(newValue) {
      this.destinationsSelected = newValue;
      this.destinations = newValue;
    },
    passengers(newValue) {
      this.passengersSelected = newValue;
      this.passengers = newValue;
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    async loadCompanyGroup() {
      const response = await ioCompanyGroups({
        empresaId: this.company.id,
        filtros: `codigo:${CODE_GROUP_DRIVERS_GORE}`
      });
      this.driverGroupId = response.data.grupos[0].id;
    },
    async loadVehiclesOptions() {
      try {
        this.isLoadVehiclesOptions = true;
        const response = await ioListOptions({
          grupoOpcion: 'io.vehiculos.gore',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.optionsVehicles = opciones
          .map((option) => {
            const extra = JSON.parse(option.extra);
            return {
              label: `(${extra.brand}) ${option.descripcion}`,
              value: option.valor,
              ...extra
            };
          })
          .sort(({ label: a }, { label: b }) => a.localeCompare(b));
      } finally {
        this.isLoadVehiclesOptions = false;
      }
    },
    async addDestination(row) {
      this.error.message = '';
      this.formData.destinations.push(row);
      this.formData.destinationsSelected.push(row);
    },
    async addPassenger(row) {
      this.error.message = '';
      this.formData.passengers.push(row);
      this.formData.passengersSelected.push(row);
    },
    async addChargeGasoline(row) {
      this.error.message = '';
      this.formData.loadsGasoline.push(row);
      this.formData.loadsGasolineSelected.push(row);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async isValid() {
      const partValidations = await Promise.all([
        this.validateForm('custom-document-part-1'),
        this.validateForm('custom-document-part-3')
      ]);

      if (partValidations.some((step) => !step)) {
        return false;
      }

      return true;
    },
    async save() {
      const isValid = await this.isValid();

      if (!isValid) {
        return;
      }
      if (!this.formData.destinationsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return;
      }
      if (!this.formData.passengersSelected.length) {
        this.error.message = 'Debes agregar al menos un pasajero';
        return;
      }
      this.error.message = '';
      this.saving = true;
      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            numerar: 'si',
            ...this.$route.query
          },
          formData: {
            ...this.formData,
            attachments: this.formData.loadsGasolineSelected.map((load) => load.voucher),
            driver: this.$refs.driver.getOption()
          }
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('BIT', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    }
  },
  created() {
    this.loadVehiclesOptions();
    this.loadCompanyGroup();
  }
};
</script>
